import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGeneratorHeroCard from '../components/ResponseBlockGeneratorHeroCard';
import { gAPI_Response_QbotAssistantOptions } from '../../../../../constants/APIs';

export default class QBotAssistantOptions extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGeneratorHeroCard getUrl={gAPI_Response_QbotAssistantOptions} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
